module.exports = __webpack_public_path__ + "static/Muli-Bold-4862b9602ec884b71c0b4175db00f92a.ttf";